import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  h: ['50px', null, '80px'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'accent',
  fontSize: 'xs',
};

export const TextItem: CSSObject = {
  color: 'white',
  textAlign: 'center',
  fontStyle: 'normal',
  fontWeight: 'normal',
};

export const LinkItem: CSSObject = {
  color: 'alpha.200',
  fontWeight: 'bold',
};
